import { render } from "./MachineDetail.vue?vue&type=template&id=5f94f130"
import script from "./MachineDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MachineDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script